<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <marca-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import MarcaShowData from "./MarcaShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "MarcaShow",
        components: {CrudShow, MarcaShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'marca.showing',
            }
        },
    }
</script>

